let css = require('./content.css');
let Orders = require('../orders');
let Users = require('../users');

class Content {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => Object.assign({}, data, { css }));
    }
}

module.exports = {
    constructor: Content,
    children: [
        {
            name: 'orders',
            component: Orders
        },
        {
            name: 'users',
            component: Users
        }
    ]
};



// WEBPACK FOOTER //
// ./components/account/content/index.js